import styled from 'styled-components';
import {
  StyledHeaderImg,
  StyledSettingBox,
  StyledSettingHeader
} from '../SettingsModal.style';
import ColsImg from './stacked-columns.svg';
import LimitToggler from '../LimitToggler/LimitToggler';
import { CONFIG_WIDGETS_NAMES } from '../../hooks/useRaWidgetsConfig/useRaWidgetsConfig';

const StyledOverTimeChartConfig = styled(StyledSettingBox)`
  & ${StyledHeaderImg} {
    width: 2.5rem;
    height: 2.5rem;
  }
`;

const WIDGET_NAME = CONFIG_WIDGETS_NAMES.OVER_TIME_CHART;

const OverTimeChartConfig = ({ formWidgetsConfig }) => {
  const { show_all_segments, limit } =
    formWidgetsConfig.widgetsConfig[WIDGET_NAME];

  return (
    <StyledOverTimeChartConfig data-cy='styled-over-time-chart-config'>
      <StyledSettingHeader>
        Breakdown over time chart
        <StyledHeaderImg src={ColsImg} />
      </StyledSettingHeader>
      <LimitToggler
        limit={limit}
        updateLimit={limit =>
          formWidgetsConfig.updateWidgetLimit(WIDGET_NAME, limit)
        }
        showAllSegments={show_all_segments}
        toggleShowAllSegments={() =>
          formWidgetsConfig.toggleShowAllSegments(WIDGET_NAME)
        }
      />
    </StyledOverTimeChartConfig>
  );
};

export default OverTimeChartConfig;
